import React, { useEffect, useState } from 'react';
import { Container, Paper } from '@mui/material';
import RunningTradesTable from '../components/running-trades-table';

const Favorites = () => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      setCurrentUser(JSON.parse(userStr));
    }
  }, []);

  return (
    <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
        <RunningTradesTable
          currentUser={currentUser}
          favoritesOnly
          title="Favorites"
          emptyMessage="No favorite trades yet"
        />
      </Paper>
    </Container>
  );
};

export default Favorites;
